// extracted by mini-css-extract-plugin
export default {"container":"Row_container__TK80S","face":"Row_face__vM5Zy"};